import { Outlet } from "react-router-dom";

import TopBar from "../components/TopBar";
import LogoBar from "../components/LogoBar";
import NavMenu from "../components/NavMenu";

export default function MainLayout() {
    return (
        <>
            {/* Top info bar (normal flow) */}
            <TopBar />

            {/* Logo & search bar (normal flow) */}
            <LogoBar />

            {/* Sticky navigation */}
            <NavMenu />

            {/* Page content */}
            <main className="bg-gray-50">
                <Outlet />
            </main>
        </>
    );
}
